import React from 'react';
import { Field } from 'react-final-form';
import { InputFieldV2Adapter, DropdownV2Adapter } from '@zola/zola-ui';

// TODO: Move file to Zola-ui

const composeValidators = (...validators) => value =>
  validators.reduce((error, validator) => error || validator(value), undefined);

export const FormInput = ({ validate, type, ...rest }) => (
  <Field
    {...rest}
    validate={validate && validate.length ? composeValidators(...validate) : null}
    component={InputFieldV2Adapter}
    type={type || 'text'}
  />
);

export const FormDropdown = ({ name, validate, ...rest }) => {
  return (
    <Field
      name={name}
      validate={validate && validate.length ? composeValidators(...validate) : null}
    >
      {fieldProps => {
        return <DropdownV2Adapter {...rest} {...fieldProps} />;
      }}
    </Field>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/form/FinalFormV2Elements.jsx